import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.1_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_typescript@5.8.3_vite@6.3.3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}